import dataTools from '../tools/data.js'

export default {
  methods: {
    initLayout(config) {
      let layoutWidth = config.autosize ? null : config.width
      let layoutHeight = config.autosize ? null : config.height
      let xRangeMode = config.xzero ? 'tozero' : 'normal'
      config.layout = {
        paper_bgcolor: this.$vuetify.theme.dark ? '#121212' : 'white',
        plot_bgcolor: this.$vuetify.theme.dark ? '#121212' : 'white',
        title: {
          text: config.name || this.mission.name,
          font: {
            family: "'Roboto', sans-serif",
            color: this.$vuetify.theme.dark ? 'white' : '#121212',
            size: 16
          }
        },
        autosize: config.autosize,
        width: layoutWidth,
        height: layoutHeight,
        hovermode: 'closest',
        xaxis: {
          title: {
            text: config.x.label + dataTools.getUnitLabel(config.x.unit),
            font: {
              family: "'Roboto', sans-serif",
              size: 14,
              color: this.$vuetify.theme.dark ? 'white' : '#121212'
            }
          },
          showgrid: true,
          domain: [0.05, 0.95],
          zeroline: true,
          rangemode: xRangeMode,
          hoverformat: '.' + dataTools.getNbToDisplay(config.x.unit) + 'f',
          tickfont: {
            color: this.$vuetify.theme.dark ? 'white' : '#121212'
          },
          gridcolor: this.$vuetify.theme.dark ? '#656565' : '',
          linecolor: this.$vuetify.theme.dark ? '#656565' : '',
          zerolinecolor: this.$vuetify.theme.dark ? 'white' : '#121212'
        },
        yaxis: {
          tickfont: {
            color: this.$vuetify.theme.dark ? 'white' : '#121212'
          },
          gridcolor: this.$vuetify.theme.dark ? '#656565' : '',
          linecolor: this.$vuetify.theme.dark ? '#656565' : '',
          zerolinecolor: this.$vuetify.theme.dark ? 'white' : '#121212'
        },
        legend: {
          traceorder: 'ascending',
          font: {
            family: "'Roboto', sans-serif",
            color: this.$vuetify.theme.dark ? 'white' : '#121212'
          }
        }
      }
      if (config.xlog) {
        config.layout.xaxis.type = 'log'
        config.layout.xaxis.autorange = true
      }
    },
 
    initScatter(config) {
      return {
        type: 'scatter',
        mode: config.scatterMode,
        textfont: {
          color:
            this.getPlotlyColors()[
              this.colorIndex % this.getPlotlyColors().length
            ]
        },
        line: {
          shape: config.scatterShape,
          color: this.getNextColor(),
          width: 1
        },
        zerolinecolor: this.$vuetify.theme.dark ? 'white' : '#121212',
        transforms: [
          {
            type: 'sort',
            target: 'x'
          }
        ],
        textposition: 'top center'
      }
    },

    initBarChart() {
      return {
        type: 'bar',
        textfont: {
          color:
            this.getPlotlyColors()[
              this.colorIndex % this.getPlotlyColors().length
            ]
        },
        zerolinecolor: this.$vuetify.theme.dark ? 'white' : '#121212',
        textposition: 'top center'
      }
    },

    addTargetsTraces(config, values) {
      config.layout.shapes = []
      config.targets.forEach((target) => {
        let currValues = this.getPlotValues(target, this.plotData)
        if (currValues.length === 0) {
          return
        }
        let shape = {
          type: 'line',
          x0: Math.min(...values.x),
          x1: Math.max(...values.x),
          line: {
            color: target.color,
            width: 1,
            dash: 'dot'
          }
        }
        switch (target.type) {
          case 'Initial':
            shape.y0 = currValues[0]
            shape.y1 = currValues[0]
            break
          case 'Final':
            shape.y0 = currValues[currValues.length - 1]
            shape.y1 = currValues[currValues.length - 1]
            break
          case 'Min':
            shape.y0 = Math.min(...currValues)
            shape.y1 = Math.min(...currValues)
            break
          case 'Max':
            shape.y0 = Math.max(...currValues)
            shape.y1 = Math.max(...currValues)
            break
        }
        config.layout.shapes.push(shape)
      })
    },

    setScatterValues(config, values) {
      if (config.scatterMode === 'markers+text') {
        if (config.scatterText.path.length === 0) {
          config.scatterText = config.y
        }
        values.text = values.y.map((val) =>
          dataTools.displayNdigits(
            val,
            dataTools.getNbToDisplay(config.scatterText.unit)
          )
        )
      }
    },

    setBasicLayoutY(config) {
      config.layout.yaxis = {
        title: {
          text: config.y.label + dataTools.getUnitLabel(config.y.unit),
          font: {
            family: "'Roboto', sans-serif",
            size: 14,
            color: this.$vuetify.theme.dark ? 'white' : '#121212'
          }
        },
        showline: true,
        zeroline: true,
        zerolinecolor: this.$vuetify.theme.dark ? 'white' : '#121212',
        rangemode: config.yzero ? 'tozero' : 'normal',
        hoverformat: '.' + dataTools.getNbToDisplay(config.x.unit) + 'f'
      }
      if (config.ylog) {
        config.layout.yaxis.type = 'log'
        config.layout.yaxis.autorange = true
      }
    },

    setMultiAxisLayout(config, index, trace, multiAxis) {
      config.layout = { ...config.layout }
      config.layout.xaxis = { ...config.layout.xaxis }
      let yn = multiAxis[index]
      let indexPlusOne = 1 + Number(index)
      let suffix = index > 0 ? '' + indexPlusOne : ''
      let axisName = 'yaxis' + suffix
      let yRangeMode = config.yzero ? 'tozero' : 'normal'
      let shiftValue = 0.07
      let leftAnchorPlot = 0
      let rightAnchorPlot = 1
      trace.yaxis = 'y' + suffix
      trace.name = yn.label + dataTools.getUnitLabel(yn.unit)
      config.layout.legend = {
        x: 0,
        y: -1,
        traceorder: 'normal',
        font: {
          color: this.$vuetify.theme.dark ? 'white' : '#121212'
        }
      }
      config.layout[axisName] = {
        title: {
          text: yn.label + dataTools.getUnitLabel(yn.unit),
          font: {
            color: trace.line.color,
            size: 14,
            family: "'Roboto', sans-serif"
          }
        },
        hoverformat: '.' + dataTools.getNbToDisplay(config.x.unit) + 'f',
        tickfont: {
          color: trace.line.color
        },
        zeroline: true,
        zerolinecolor: this.$vuetify.theme.dark ? 'white' : '#121212',
        rangemode: yRangeMode,
        range: [Math.min(...trace.y), Math.max(...trace.y)],
        autorange: true
      }
      if(multiAxis.length==1){
        config.layout[axisName].gridcolor= this.$vuetify.theme.dark ? '#656565' : ''
        }
      // Reimplemented rangemode here because plotly seems to ignore tozero option when ploting multiaxis
      if (yRangeMode === 'tozero') {
        config.layout[axisName].range[0] = 0
      }
      if (index > 0) {
        config.layout[axisName].overlaying = 'y'
        config.layout[axisName].anchor = 'free'
        if (index % 2 === 0) {
          config.layout[axisName].side = 'left'
          leftAnchorPlot += shiftValue * (index - 1)
          config.layout[axisName].position = leftAnchorPlot
        } else {
          config.layout[axisName].side = 'right'
          rightAnchorPlot -= shiftValue * (index - 1)
          config.layout[axisName].position = rightAnchorPlot
        }
      }
      config.layout.xaxis.domain = [
        multiAxis.length * shiftValue,
        rightAnchorPlot
      ]
    },

    getMapType(type) {
      let traceType
      switch (type) {
        case 'Contour map':
          traceType = 'contour'
          break
        case 'Heat Map':
          traceType = 'heatmap'
          break
        case 'Surface':
          traceType = 'surface'
          break
        default:
          traceType = 'contour'
          break
      }
      return traceType
    },

    setMapLayout(traceType, config) {
      return {
        type: traceType,
        line: {
          smoothing: 0.85
        },
        connectgaps: false,
        colorbar: {
          title: {
            text: config.z.label + dataTools.getUnitLabel(config.z.unit),
            font: {
              family: "'Roboto', sans-serif",
              size: 13,
              color: this.$vuetify.theme.dark ? 'white' : '#121212'
            }
          },
          tickfont: {
            color: this.$vuetify.theme.dark ? 'white' : '#121212'
          },
        }
      }
    },

    setMapAxisTitles(config) {
      config.layout.scene = {
        xaxis: {
          title: config.x.label + dataTools.getUnitLabel(config.x.unit)
        },
        yaxis: {
          title: config.y.label + dataTools.getUnitLabel(config.y.unit)
        },
        zaxis: {
          title: config.z.label + dataTools.getUnitLabel(config.z.unit)
        },
        autosize: true
      }
    },

    getNextColor() {
      return this.getPlotlyColors()[
        this.colorIndex++ % this.getPlotlyColors().length
      ]
    },

    getPlotlyColors() {
      return [
        '#2a94de',
        '#ff7f0e',
        '#2ca02c',
        '#d62728',
        '#9467bd',
        '#8c564b',
        '#e377c2',
        '#7f7f7f',
        '#bcbd22',
        '#17becf'
      ]
    }
  }
}
